import React from 'react'
import { Link } from '@inertiajs/react'

interface PaginationProps {
  currentPage: number
  totalPages: number
  totalCount: number
}

const Pagination: React.FC<PaginationProps> = ({ currentPage, totalPages }) => {
  const getPageUrl = (page: number) => {
    const params = new URLSearchParams(window.location.search)
    params.set('page', page.toString())
    return `${window.location.pathname}?${params.toString()}`
  }

  const renderPageNumbers = () => {
    const pageNumbers = []
    for (let i = 1; i <= totalPages; i++) {
      pageNumbers.push(
        <Link
          key={i}
          href={getPageUrl(i)}
          className={`px-3 py-1 mx-1  no-underline ${
            currentPage === i ? 'text-black font-bold border-b-4 border-black' : 'text-blue-600 hover:text-blue-800'
          }`}
        >
          {i}
        </Link>
      )
    }
    return pageNumbers
  }

  return (
    <div className="flex justify-center items-center mt-8">
      {renderPageNumbers()}
      {currentPage < totalPages && (
        <Link
          href={getPageUrl(currentPage + 1)}
          className="px-3 py-1 mx-1 text-blue-600 hover:text-blue-800 flex items-center"
        >
          Siguiente
          <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </Link>
      )}
    </div>
  )
}

export default Pagination
